import React, { useState, useEffect } from 'react';
import { getCommentsByPubApi } from '../../../../api/comment';
import { getAccessTokenApi } from '../../../../api/auth';
import { Link } from 'react-router-dom';
import moment from 'moment';

export default function ShowComment(props) {
    const { comments } = props;
    const [ commentData, setCommentData ] = useState([]);
    const [ reloadCommentData, setReloadCommentData ] = useState([]);

    useEffect(() => {
        let token = getAccessTokenApi();
        getCommentsByPubApi(token, comments._id).then(response => {
            setCommentData(response.comment);
        });

        setReloadCommentData(false);
    }, [reloadCommentData, comments._id]);

    return (
        <>
            <div className="modal-body">
                <>
                    {Array.from(commentData).map((commentario, index) => {
                        return(
                            <div key={index} className="row">
                                <div className="col-12">
                                    <div className="card shadow mt-3">
                                        <div className="card-body">
                                            <h3 id="responsive-meta-tag">
                                                <span className="float-right text-primary" style={{'marginTop': '-1em', 'fontSize': '12px'}}>Fecha Comentario : {moment(commentario.fc_comentario).format("DD/MM/YYYY HH:mm:ss")}</span>
                                            </h3>
                                            <span className="text-left">{commentario.gl_comentario}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </>
            </div>
            <div className="col-12 text-center">
                <Link to={"/search/"+comments.url} className="btn btn-success text-white ml-3 mb-3" type="button" data-dismiss="modal">Ir a Publicación</Link>
        </div>
      </>
    )
}
